<template>
  <v-dialog v-model="show" width="500px">
    <v-card>
      <v-container>
        <v-card-title>
          <v-col cols="12">
            <label>TEAM</label>
            <v-autocomplete
              v-model="userData"
              :items="userList"
              clearable
              filled
              label="choose teams"
              item-text="full_name"
              color="blue-grey lighten-2"
              item-value="id"
              multiple
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  @click="data.select"
                >
                  {{ data.item.full_name }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </v-card-title>
        <v-card-actions>
          <v-btn rounded color="info" @click="addUser">Add</v-btn>
          <v-btn rounded color="secondary" @click="clearUser">Cancel</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions} from "vuex";
import DEFAULT_CONSTANTS from "@/Utilites/constants";

export default {
  name: "ProjectTeamAdd",
  props: ["userList", "userAdd"],
  data() {
    return {
      userData: [],
    };
  },
  computed: {
    show: {
      get() {
        return this.userAdd;
      },
      set(show) {
        this.$emit("update-add-user-modal", show);
      },
    },
  },
  methods: {
    ...mapActions([
      "CreateProjectUser",
      "showLoadingProcess",
      "closeLoading",
      "showSnackBar",
      "closeSnackBar",
    ]),
    clearUser() {
      this.show = false;
      this.userData = [];
    },
    async addUser() {
      await this.showLoadingProcess();
      try {
        const value = {
          project_id: this.$route.query.project_id,
          user_id: this.userData,
        };
        await this.CreateProjectUser(value);
        await this.closeLoading();
        this.clearUser();
        await this.showSnackBar({
          text: "User has been added to Project",
          color: DEFAULT_CONSTANTS.success,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      } catch (err) {
        this.clearUser();
        await this.closeLoading();
        await this.showSnackBar({
          text: JSON.stringify(err),
          color: DEFAULT_CONSTANTS.error,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },
  },
};
</script>

<style scoped></style>
